import * as types from '../actions/types'


const servicesReducer = (state = {}, action) => {
    switch(action.type) {
        case types.FETCH_SERVICES_SUCCESS:
            const servicesById = changeServicesStructure(action.services);
            return { ...state, services: action.services, servicesById: servicesById };
        default:
            return state;
    }
}

function changeServicesStructure(services) {
    var structuredServices = {};
    services.map((service, index) => {
        return (
            structuredServices[service.id] = {
                ...service
            }
        )
    });

    return structuredServices;
}

export default servicesReducer;


// WEBPACK FOOTER //
// ./src/reducers/servicesReducer.js